import React, { useMemo } from "react";
import styled from "styled-components";

import * as flomoji from "@floji-internal/noto-emoji";

import { EmojiSprite } from "--components/emoji";
import { Body1, Body2, Body3 } from "--components/typography";

interface StyledEmojiDetailsProps {
    visible?: boolean;
}
const StyledEmojiDetails = styled.div.attrs((props: StyledEmojiDetailsProps) => ({
    style: {
        display: props.visible ? "flex" : "none"
    }
})) <StyledEmojiDetailsProps>`
    align-items: center;
    background: ${props => props.theme.palette.surface};
    bottom: 0;
    box-sizing: border-box;
    display: flex;
    height: 100%;
    left: 0;
    padding: ${props => props.theme.spacing(1, 2)};
    position: absolute;
    right: 0;
    top: 0;
`;
const EmojiDetailsDetails = styled.div`
    flex: 1 1 auto;
    margin-left: ${props => props.theme.spacing(1)};
`;
const EmojiDetailsName = styled(Body1)`white-space: nowrap;`;
const EmojiDetailsShortcut = styled(Body2)`white-space: nowrap;`;
const EmojiDetailsWords = styled(Body3)`white-space: nowrap;`;

interface EmojiDetailsProps {
    emoji?: flomoji.tPickerEmoji;
    tone?: flomoji.tSkinTone;
}
/** Extended details about given emoji. */
const EmojiDetails = (props: EmojiDetailsProps) => {
    const sprite = useMemo(() => (
        props.tone
            ? props.emoji?.tones?.[props.tone]?.sprite ?? props.emoji?.sprite
            : props.emoji?.sprite
    ), [props.emoji, props.tone]);

    const words = useMemo(
        () => props.emoji?.words?.join(", "),
        [props.emoji?.words]
    );

    return (
        <StyledEmojiDetails
            visible={sprite !== undefined && props.emoji !== undefined}
        >
            <EmojiSprite emoji={sprite || 0} size={42} />
            <EmojiDetailsDetails>
                <EmojiDetailsName>{props.emoji?.name}</EmojiDetailsName>
                <EmojiDetailsShortcut>{props.emoji?.shortcut}</EmojiDetailsShortcut>

                {words && <EmojiDetailsWords>{words}</EmojiDetailsWords>}
            </EmojiDetailsDetails>
        </StyledEmojiDetails>
    );
};

export default EmojiDetails;
